import {
  Calendar,
  Users,
  DollarSign,
  ArrowRight,
  CheckCircle,
} from "lucide-react";
import finances from "../../../resources/finances.png";

const AppShowcase = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-purple-50 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Profesional, simple y{" "}
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              potente
            </span>
          </h2>
          <p className="text-xl sm:text-2xl text-slate-600 mb-8 leading-relaxed">
            Accede desde cualquier lugar. Tu consultorio en tu bolsillo.
          </p>
        </div>

        {/* Three Phone Mockups with Features */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 items-start">
          {/* Phone 1 - Calendar */}
          <div className="flex flex-col items-center">
            <div className="relative group">
              {/* Phone Frame */}
              <div className="relative mx-auto w-[280px] sm:w-[300px] bg-slate-900 rounded-[3rem] p-3 shadow-2xl ring-8 ring-slate-900/5 transition-transform group-hover:scale-105 duration-300">
                {/* Notch */}
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-7 bg-slate-900 rounded-b-3xl z-10"></div>

                {/* Screen */}
                <div className="relative bg-white rounded-[2.5rem] overflow-hidden aspect-[9/19.5]">
                  <img
                    src="/mnt/user-data/uploads/1762974555331_image.png"
                    alt="OdontoStark Agenda"
                    className="w-full h-full object-cover object-top"
                  />

                  {/* Gradient Overlay for depth */}
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-600/5 to-transparent pointer-events-none"></div>
                </div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -right-4 top-8 bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-full shadow-lg text-sm font-semibold transform rotate-3 group-hover:rotate-6 transition-transform">
                ⚡ En tiempo real
              </div>
            </div>

            {/* Feature Description */}
            <div className="mt-8 text-center max-w-xs">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center text-white mb-4 mx-auto shadow-lg">
                <Calendar className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                Agenda Visual
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Ve tu día de un vistazo. Gestiona citas con solo un toque.
              </p>
            </div>
          </div>

          {/* Phone 2 - Patients */}
          <div className="flex flex-col items-center md:mt-12">
            <div className="relative group">
              <div className="relative mx-auto w-[280px] sm:w-[300px] bg-slate-900 rounded-[3rem] p-3 shadow-2xl ring-8 ring-slate-900/5 transition-transform group-hover:scale-105 duration-300">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-7 bg-slate-900 rounded-b-3xl z-10"></div>

                <div className="relative bg-white rounded-[2.5rem] overflow-hidden aspect-[9/19.5]">
                  <img
                    src="/mnt/user-data/uploads/1762974561598_image.png"
                    alt="OdontoStark Pacientes"
                    className="w-full h-full object-cover object-top"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-purple-600/5 to-transparent pointer-events-none"></div>
                </div>
              </div>

              <div className="absolute -left-4 top-12 bg-gradient-to-r from-purple-500 to-purple-600 text-white px-4 py-2 rounded-full shadow-lg text-sm font-semibold transform -rotate-3 group-hover:-rotate-6 transition-transform">
                📋 Todo guardado
              </div>
            </div>

            <div className="mt-8 text-center max-w-xs">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center text-white mb-4 mx-auto shadow-lg">
                <Users className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                Base de Pacientes
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Historial completo, alertas médicas y búsqueda instantánea.
              </p>
            </div>
          </div>

          {/* Phone 3 - Financial */}
          <div className="flex flex-col items-center">
            <div className="relative group">
              <div className="relative mx-auto w-[280px] sm:w-[300px] bg-slate-900 rounded-[3rem] p-3 shadow-2xl ring-8 ring-slate-900/5 transition-transform group-hover:scale-105 duration-300">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-7 bg-slate-900 rounded-b-3xl z-10"></div>

                <div className="relative bg-white rounded-[2.5rem] overflow-hidden aspect-[9/19.5]">
                  <img
                    src={finances}
                    alt="OdontoStark Finanzas"
                    className="w-full h-full object-cover object-top"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-emerald-600/5 to-transparent pointer-events-none"></div>
                </div>
              </div>

              <div className="absolute -right-4 top-16 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white px-4 py-2 rounded-full shadow-lg text-sm font-semibold transform rotate-3 group-hover:rotate-6 transition-transform">
                💰 Reportes auto
              </div>
            </div>

            <div className="mt-8 text-center max-w-xs">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-xl flex items-center justify-center text-white mb-4 mx-auto shadow-lg">
                <DollarSign className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                Panel Financiero
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                Visualiza ingresos, cobros pendientes y tendencias al instante.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <a
            href="/registrarse"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-2xl shadow-blue-600/40 hover:shadow-blue-600/60 hover:scale-105"
          >
            Empieza tu prueba gratis
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default AppShowcase;
